<template>
	<CharacteristicInline
		:value="value"
		:characteristic-items="meta.companyType"
		:characteristic-type="meta.companyTypeType"
		single-choice
		initial-show-all
		label-type="job-profile"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicInline from "@/vue/characteristic/SelectInline";

export default {
	components: {
		CharacteristicInline
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},
}
</script>
